module.exports = __webpack_public_path__ + "media/text2audio.50636442.mp3";